<template>
  <div class="activity">
    <div class="contentBox">
      <div class="content">
        <div class="information">
          <div
            class="container"
            v-for="item in psychologyList"
            :key="item.id"
            @click="startTest(item.oneLevelId, item.testName, item.type)"
          >
            <img :src="item.imageUrl" alt="" />
            <span class="message">{{ item.testName }}</span>
          </div>
          <van-loading
            size="24px"
            style="margin: 0 auto"
            v-if="!psychologyList.length"
            >加载中...</van-loading
          >
        </div>
      </div>
    </div>
    <div class="drawBox">
      <div class="draw" @click="getDrawInfo">
        <span class="title">立即抽奖</span>
        <span class="number" v-if="drawNumber">×{{ drawNumber }}</span>
      </div>
    </div>
    <div class="rule" @click="getRuleInfo">
      <img src="@/assets/vote/rule.png" alt="" />
    </div>
    <van-overlay :show="showShade">
      <div class="shake">
        <img
          src="https://res1.qdszgh.cn/%E5%BF%83%E7%90%86/%E5%BF%83%E7%90%86%E6%B4%BB%E5%8A%A8/shake.gif"
          alt=""
        />
      </div>
    </van-overlay>
    <van-dialog
      class="lucky_dialog"
      v-model="showLottery"
      :showConfirmButton="false"
    >
      <div class="information">
        <span class="title">{{ awardName }}</span>
        <span class="message">{{ prizeName }}</span>
        <div class="address" v-if="awardLevel" @click="getAddressInfo">
          <img src="@/assets/vote/address.png" alt="" />
        </div>
        <div class="close" @click="closeDialog">
          <img src="@/assets/vote/close.png" alt="" />
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {
  getAcitivityFlag,
  getScaleActivityList,
  getMyLotteryDrawNumber,
  ltteryDrawing,
} from "@/api/system/activity";
import { Toast } from "mint-ui";
export default {
  name: "activity",
  data() {
    return {
      psychologyList: [], //心理测评量表
      drawNumber: 0, //默认抽奖次数为0
      showLottery: false, //默认不显示中奖信息弹窗
      showShade: false, //默认不显示遮罩层
      awardLevel: 0, //是否中奖
      awardName: "", //奖品标题
      prizeName: "", //奖品内容
    };
  },
  methods: {
    getPsychologyList() {
      getScaleActivityList()
        .then((res) => {
          if (res.code == 200) {
            this.psychologyList = res.data.reverse();
          }
        })
        .then(() => {
          this.getDrawNumber();
        });
    },
    //获取抽奖次数
    getDrawNumber() {
      getMyLotteryDrawNumber().then((res) => {
        if (res.code == 200) {
          this.drawNumber = res.data;
        }
      });
    },
    startTest(id, testName, type) {
      getAcitivityFlag().then((res) => {
        if (res.code == 200) {
          // 立即测评
          if (testName == "匹兹堡睡眠质量指数") {
            this.miniJump(`/sleep?id=${id}&type=${type}`)
          } else {
            this.miniJump(`/detection?id=${id}&type=${type}`)
          }
        } else {
          Toast({
            message: res.msg,
            duration: 1500,
          });
        }
      });
    },
    //获取规则信息
    getRuleInfo() {
      this.miniJump(`/activityRule`)
    },

    getDrawInfo() {
      if (this.drawNumber) {
        ltteryDrawing().then((res) => {
          if (res.code == 200) {
            this.showShade = true;
            this.awardLevel = res.data.awardLevel;
            this.awardName = res.data.awardName;
            this.prizeName = res.data.prizeName;
            setTimeout(() => {
              this.showShade = false;
              this.showLottery = true;
              this.getDrawNumber();
            }, 2000);
          } else {
            Toast({
              message: res.msg,
              duration: 1500,
            });
          }
        });
      } else {
        Toast({
          message: "当前抽奖次数为0",
          duration: 1500,
        });
      }
    },
    getAddressInfo() {
      this.miniJump(`/receiveAddress`)
    },
    closeDialog() {
      this.showLottery = false;
    },
  },
  created() {
    setTimeout(() => {
      this.getPsychologyList();
    }, 1000);
  },
};
</script>

<style lang="scss" scoped>
.activity {
  height: 100vh;
  background: url("https://res1.qdszgh.cn/%E5%BF%83%E7%90%86/%E5%BF%83%E7%90%86%E6%B4%BB%E5%8A%A8/activity_bg.png")
    no-repeat center;
  background-size: 100% 100%;
  .contentBox {
    display: flex;
    justify-content: center;
    .content {
      width: 90vw;
      height: 130vw;
      display: flex;
      justify-content: center;
      background: url("https://res1.qdszgh.cn/%E5%BF%83%E7%90%86/%E5%BF%83%E7%90%86%E6%B4%BB%E5%8A%A8/activity_frame.png")
        no-repeat center;
      background-size: 100% 100%;
      margin: 17px 0 0;
      .information {
        width: 95%;
        height: calc(100% - 95px);
        display: flex;
        flex-wrap: wrap;
        margin: 65px 0 0;
        overflow-y: scroll;
        align-content: flex-start;
        .container {
          width: 60px;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin: 0 0 15px 16px;
          img {
            width: 64px;
            height: 70px;
          }
          .message {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 16px;
            text-align: center;
            margin: 6px 0 0;
          }
        }
      }
      .information::-webkit-scrollbar {
        display: none;
      }
    }
  }
  .drawBox {
    display: flex;
    justify-content: center;
    .draw {
      width: 120px;
      height: 40px;
      background: url("https://res1.qdszgh.cn/%E5%BF%83%E7%90%86/%E5%BF%83%E7%90%86%E6%B4%BB%E5%8A%A8/draw.png")
        no-repeat center;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 30px 0 0;
      .title,
      .number {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #b82b00;
        line-height: 15px;
        margin: 0 0 0 5px;
      }
    }
  }
  .rule {
    display: flex;
    position: absolute;
    top: 12px;
    right: 38px;
    img {
      width: 30px;
      height: 38px;
    }
  }
  .shake {
    display: flex;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    img {
      width: 283px;
      height: 371px;
    }
  }
  .lucky_dialog {
    width: 90vw;
    height: 100vw;
    display: flex;
    justify-content: center;
    background: url("../../assets/vote/lucky_dialog.png") no-repeat;
    background-size: 100% 100%;
    .information {
      display: flex;
      flex-direction: column;
      align-items: center;
      .title {
        font-size: 32px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #fda464;
        background: linear-gradient(180deg, #e8642f 0%, #fda464 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        position: absolute;
        top: 30%;
      }
      .message {
        width: 1.79rem;
        font-size: 15px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        position: absolute;
        top: 55%;
      }
      .address {
        display: flex;
        position: absolute;
        bottom: 21%;
        img {
          width: 1.84rem;
          height: 0.5rem;
        }
      }
      .close {
        display: flex;
        position: absolute;
        bottom: 0;
        img {
          width: 0.36rem;
          height: 0.36rem;
        }
      }
    }
  }
}
</style>
